
import { Factory, Cog, Hammer, Wrench, Cpu, Car } from "lucide-react";

const IndustryCard = ({ 
  title, 
  titleCn, 
  icon: Icon 
}: { 
  title: string;
  titleCn: string;
  icon: React.ElementType;
}) => {
  return (
    <div className="industry-card">
      <div className="mb-4 bg-wiiseng-blue/10 p-4 rounded-full">
        <Icon className="h-10 w-10 text-wiiseng-blue" />
      </div>
      <h3 className="text-lg font-semibold mb-1">{title}</h3>
      <p className="text-wiiseng-gray">{titleCn}</p>
    </div>
  );
};

const IndustriesSection = () => {
  const industries = [
    {
      title: "Automotive",
      titleCn: "汽车制造",
      icon: Car
    },
    {
      title: "General Machinery",
      titleCn: "通用机械",
      icon: Cog
    },
    {
      title: "Mould & Die",
      titleCn: "模具制造",
      icon: Hammer
    },
    {
      title: "Metal Fabrication",
      titleCn: "金属加工",
      icon: Wrench
    },
    {
      title: "Electronics",
      titleCn: "电子产品",
      icon: Cpu
    },
    {
      title: "Industrial Manufacturing",
      titleCn: "工业制造",
      icon: Factory
    }
  ];

  return (
    <section id="industries" className="py-16 md:py-24 bg-wiiseng-lightgray">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Industries We Support</h2>
          <p className="text-lg text-wiiseng-gray max-w-2xl mx-auto">
            Reliable CNC machining and repair services trusted across a wide range of industries
          </p>
          <p className="text-lg text-wiiseng-gray max-w-2xl mx-auto">
            为众多行业提供可靠的CNC加工与维修服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {industries.map((industry, index) => (
            <IndustryCard key={index} {...industry} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
